import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const AnalisisRequerimientos = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/03-analisis-de-requerimientos.pdf`;
  /*const pdfUrl = "/pdf/03-analisis-de-requerimientos.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Análisis de Requerimientos</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Análisis de Requerimientos" />
      </Container>
    </>
  );
};

 export default AnalisisRequerimientos;
